var map = {
	"./de-de.po": 1968,
	"./en-ca.po": 1969,
	"./en-gb.po": 1970,
	"./en-ie.po": 1971,
	"./en-us.po": 1972,
	"./es-es.po": 1973,
	"./es-mx.po": 1974,
	"./fr-ca.po": 1975,
	"./fr-fr.po": 1976,
	"./hr-hr.po": 1977,
	"./it-it.po": 1978,
	"./nl-nl.po": 1979,
	"./pl-pl.po": 1980
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	if(!__webpack_require__.m[id]) {
		var e = new Error("Module '" + req + "' ('" + id + "') is not available (weak dependency)");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
webpackContext.id = 1941;
module.exports = webpackContext;